import { type ShippingCountryCode } from "@/data/shipping-country-code"
import * as v from "valibot"

export const SHIPPING_COUNTRIES = {
    Austria: "austria",
    Australia: "australia",
    Belgium: "belgium",
    Bulgaria: "bulgaria",
    Canada: "canada",
    Croatia: "croatia",
    Cyprus: "cyprus",
    CzechRepublic: "czech republic",
    Denmark: "denmark",
    Estonia: "estonia",
    UnitedKingdom: "united kingdom",
    Finland: "finland",
    France: "france",
    Germany: "germany",
    Greece: "greece",
    Hungary: "hungary",
    Italy: "italy",
    Ireland: "ireland",
    Japan: "japan",
    Latvia: "latvia",
    Lithuania: "lithuania",
    Luxembourg: "luxembourg",
    Malta: "malta",
    Netherlands: "netherlands",
    NewZealand: "new zealand",
    Norway: "norway",
    Poland: "poland",
    Portugal: "portugal",
    Romania: "romania",
    Slovakia: "slovakia",
    Slovenia: "slovenia",
    Spain: "spain",
    Sweden: "sweden",
    Switzerland: "switzerland",
    USA: "united states"
} as const

// Used mainly in Wrong Site Popup
export const SHIPPING_COUNTRY_ADJECTIVES = {
    Austria: "Austrian",
    Australia: "Australian",
    Belgium: "Belgian",
    Bulgaria: "Bulgarian",
    Canada: "Canadian",
    Croatia: "Croatian",
    Cyprus: "Cypriot",
    Czechia: "Czech",
    Denmark: "Danish",
    Estonia: "Estonian",
    "United Kingdom of Great Britain and Northern Ireland": "British",
    Finland: "Finnish",
    France: "French",
    Germany: "German",
    Greece: "Greek",
    Hungary: "Hungarian",
    Italy: "Italian",
    Ireland: "Irish",
    Japan: "Japanese",
    Latvia: "Latvian",
    Lithuania: "Lithuanian",
    Luxembourg: "Luxembourgish",
    Malta: "Maltese",
    Netherlands: "Dutch",
    "New Zealand": "New Zealander",
    Norway: "Norwegian",
    Poland: "Polish",
    Portugal: "Portuguese",
    Romania: "Romanian",
    Slovakia: "Slovak",
    Slovenia: "Slovenian",
    Spain: "Spanish",
    Sweden: "Swedish",
    Switzerland: "Swiss",
    "United States of America": "American"
} as const

export type ShippingCountry = (typeof SHIPPING_COUNTRIES)[keyof typeof SHIPPING_COUNTRIES]
export type ShippingCountryKey = keyof typeof SHIPPING_COUNTRIES

export const getCountryKeyFromCountryValue = (
    countryValue: ShippingCountry
): ShippingCountryKey | undefined => {
    const entries = Object.entries(SHIPPING_COUNTRIES) as [
        ShippingCountryKey,
        ShippingCountry
    ][]
    const foundEntry = entries.find(([, value]) => value === countryValue)
    return foundEntry ? foundEntry[0] : undefined
}

interface ShippingCountryOption {
    value: ShippingCountry
    label: string
    isSelected?: boolean
}

export const countries: ShippingCountryOption[] = Object.values(SHIPPING_COUNTRIES).map(
    (countryName, index) => ({
        value: countryName,
        label: countryName,
        isSelected: false
    })
)

export interface RadioButtonProps {
    options: ShippingCountryOption[]
    name?: string
}

/* Zod Runtime Types */

const ShippingCountryValues = v.picklist(
    Object.values(SHIPPING_COUNTRIES) as [ShippingCountry, ...ShippingCountry[]]
)

export const validateShippingCountry = (country: ShippingCountryCode) =>
    v.safeParse(ShippingCountryValues, country)
